module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BoldItalic.b269a785.eot";